import { render, staticRenderFns } from "./ProposalWrapper.vue?vue&type=template&id=3af9239f&"
import script from "./ProposalWrapper.vue?vue&type=script&lang=js&"
export * from "./ProposalWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports